import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';

class SurveySectionItem extends Component {
    static propTypes = {
        surveys: PropTypes.array.isRequired,
        memberReference: PropTypes.string
    };

    render() {
        const { memberReference, surveys } = this.props;

        return (
            <Field
                name={memberReference ? `${memberReference}.content.surveyId` : 'content.surveyId'}
                label={'Survey'}
                options={surveys}
                valueKey={'_id'}
                labelKey={'title'}
                component={BasicSelect}
            />
        );
    }
}

export default SurveySectionItem;
